import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss', './../ifacss.scss']
})
export class AboutComponent implements OnInit {
  aboutusparagraph: any;

  constructor() {}

  ngOnInit(): void {
    debugger;
    this.aboutusparagraph = sessionStorage.getItem('ihjt45h45=a');
  }
  modalPopOpen() {
    $('#LetsTalk_popup').modal('show');
  }
}
